//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/javascript/util'
import EsQuery from '@/javascript/esQuery'
import { formatDate } from "@/javascript/formatDate"
import goSearch from '@/components/lyx-components/search-box/index.vue'
import tabWrap from '@/components/lyx-components/tab-wrap/index.vue'
import goBack from '@/components/public-components/goBack/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
  components: {
    goSearch,
    tabWrap,
    goBack,
    Footer
  },
  data () {
    return {
      minHeight: 0,
      pageNo: 0,
      pageSize: 10,
      infiniteAll: false,
      infiniteStatus: false,
      strategyList: [],
      tabIndex: this.$route.params.tab,
      tabItems: ['全部', '摄影', '城市观光', '徒步', '爬山', '寻访']
    }
  },
  mounted () {
    this.minHeight = document.documentElement.clientHeight
    document.title = "游记"
    // this.tabIndex = 0
    this.getStrategyList()
    /**
     * 微信签名分享
     */
    if (util.isWeiXin()) {
      const shareData = typeof (shareData) === 'undefined' ? {
        title: '游记',
        desc: this.SHARE_TEXT,
        imgUrl: this.SHARE_IMG,
        link: window.location.href
      } : shareData
      this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href.split('#')[0]) + '&appId=' + this.WX_APPID).then((response) => {
        util.initWxConfig(response.data.data, shareData)
      })
    }
  },
  methods: {
    tabHandler (index) {
      this.tabIndex = index
      // this.strategyList = []
      this.pageNo = 0,
        this.pageSize = 10,
        this.infiniteAll = false,
        this.infiniteStatus = false,
        this.$router.replace(`/strategyList/${index}`)
      this.getStrategyList()
    },

    getStrategyList (moreData) {
      const querystring = require('querystring')
      const travelsEsQuery = new EsQuery()
      travelsEsQuery
        .addStartWith("deptCode", this.DEPT_CODE.DEPTCODE, travelsEsQuery.and, false)
        // .addString("publishStatus", 1, travelsEsQuery.and, false)
        // .addPattern("noteType", '*1*', travelsEsQuery.and, false)
        // .addSort("updateDate", travelsEsQuery.desc, false)
        .addPage(this.pageNo * this.pageSize, this.pageSize)
      if (this.tabItems[this.tabIndex] != '全部') {
        travelsEsQuery.addString("tags", this.tabItems[this.tabIndex], travelsEsQuery.and, false)
      }
      const travelsEsJsonQuery = JSON.stringify(travelsEsQuery.getArray())
      this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
        'indexName': this.INDEX_NAME_TYPE.travelList,
        'esJsonQuery': travelsEsJsonQuery
      })).then(res => {
        window.addEventListener('scroll', this.windowScroll) // 监听滚动
        res.data.data.forEach(item => item._source.updateDate = formatDate(item._source.updateDate, "MM-dd"))
        if (moreData) {
          this.strategyList = [...this.strategyList, ...res.data.data]
        } else {
          this.strategyList = res.data.data
        }
        if (res.data.data.length < this.pageSize) {
          this.infiniteAll = true
        }
        this.infiniteStatus = false
      })
    },
    windowScroll () {
      // 底部加载
      if (util.pullUpLoad()) {
        this.infinite()
      }
    },
    infinite () {
      if (this.infiniteAll) {
        return
      }
      if (this.infiniteStatus) {
        return
      }
      this.pageNo += 1
      this.getStrategyList(true)
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.windowScroll)
  }
}
